import { createStore, Store, useStore as baseUseStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import brandModule, { BrandState } from "@/store/modules/brand";
import productModule, { ProductState } from "@/store/modules/product";
import systemModule, { SystemState } from "@/store/modules/system";
import authModule, { AuthState } from "@/store/modules/auth";
import customerModule, { CustomerState } from "@/store/modules/customer";
import tariffModule, { TariffState } from "@/store/modules/tariff";
import premiumModule, { PremiumState } from "@/store/modules/premium";
import roamingModule, { RoamingState } from "@/store/modules/roaming";
import historyModule, { HistoryState } from "@/store/modules/history";
import feedbackModule, { FeedbackState } from "@/store/modules/feedback";
import faqModule, { FaqState } from "@/store/modules/faq";
import analyticsModule, { AnalyticsState } from "@/store/modules/analytics";
import { allBrands, defaultBrand } from "@/config/brands";
import { InjectionKey } from "vue";

export interface RootState {
  customer: CustomerState;
  product: ProductState;
  roaming: RoamingState;
  tariff: TariffState;
  system: SystemState;
  auth: AuthState;
  premium: PremiumState;
  brand: BrandState;
  history: HistoryState;
  faq: FaqState;
  feedback: FeedbackState;
  analytics: AnalyticsState;
}
export const key: InjectionKey<Store<RootState>> = Symbol();

export function useStore() {
  return baseUseStore(key);
}

export default createStore<RootState>({
  state: {} as RootState,
  getters: {},
  mutations: {},
  actions: {
    clearLocalDataStore({ dispatch }) {
      //Удаление конф. данных из локального стора paths: ["subscriptionDetails", "mainTariff", "brand.operatorSource"],
      //в том числе и всех данные по тарифу
      dispatch("tariff/clearTariffStore", null, { root: true });
      dispatch("brand/removeOperatorSource", defaultBrand, { root: true });
    },
  },
  modules: {
    brand: brandModule,
    product: productModule,
    system: systemModule,
    auth: authModule,
    customer: customerModule,
    tariff: tariffModule,
    premium: premiumModule,
    roaming: roamingModule,
    history: historyModule,
    feedback: feedbackModule,
    faq: faqModule,
    analytics: analyticsModule,
  },
  plugins: [
    createPersistedState({
      key: "moi-operator-store", // optional, default is "vuex"
      storage: window.localStorage, // or window.sessionStorage
      paths: [
        "tariff.subscriptionDetails",
        "tariff.mainTariff",
        "brand.operatorSource",

        "analytics.visitCount",
        "feedback.feedbackShownVisits",
        "feedback.feedbackSubmitted",
        "system.promoModalShown",
      ], // optional, persist only specific parts of state
      getState: (key) => {
        const rawValue = localStorage.getItem(key);
        if (!rawValue) return undefined;
        try {
          const parsed = JSON.parse(rawValue);
          if (
            parsed.brand &&
            !allBrands.includes(parsed.brand.operatorSource)
          ) {
            console.warn(
              "Обнаружен невалидный бренд в localStorage! Сброс на дефолтный."
            );
            parsed.brand.operatorSource = defaultBrand;
          }
          return parsed;
        } catch (e) {
          localStorage.removeItem(key);
          return undefined;
        }
      },
    }),
  ],
});
